import React, { useEffect } from "react";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import {
  CountryStateCityAreaContextImport,
  CountryStateCityAreaContextProvider,
} from "../../../provider/country_state_city_area/country_state_city_area/CountryStateCityAreaContextProvider";
import { useSelector } from "react-redux";
import { RootState } from "../../../libraries/state_reducers/store";
import Div from "../../../widget/common/ui/Div";
import Loader from "../../../widget/common/ui/Loader";
import { Listing, ListItem } from "../../../widget/common/ui/Listing";
import { TextBlock } from "../../../widget/common/ui/Text";
import { textCase } from "../../../service/ui/UI";
import Center from "../../../widget/common/ui/Center";
import SearchInput from "../../../widget/common/form/SearchInput";

const GeoAlert = () => {
  const type: number = ResponsiveDeviceType();

  return (
    <CountryStateCityAreaContextProvider>
      <GeoAlertBody type={type} />
    </CountryStateCityAreaContextProvider>
  );
};

export default GeoAlert;

const GeoAlertBody = (props: { type: number }) => {
  const flag = useSelector((state: RootState) => state.geoAlert.flag);

  const {
    clickList,
    listResult,
    getListAPI,
    handleOnChange,
    clearSearch,
    searchValue,
  } = CountryStateCityAreaContextImport();

  useEffect(() => {
    console.log(flag);
    getListAPI(flag);
    // eslint-disable-next-line
  }, [flag]);

  return (
    <Div>
      {listResult == null ? (
        <Center>{Loader.normal()}</Center>
      ) : (
        <>
          <SearchInput
            name="search-location-geo"
            placeHolder="search"
            handleOnChange={handleOnChange}
            onClickSuffix={clearSearch}
            value={searchValue}
            autoFocus={true}
          />
          <Listing fixedHieght={true}>
            {(listResult ?? []).map((detail, key) => (
              <ListItem key={key}>
                <div role="button" onClick={() => clickList(flag, detail)}>
                  <TextBlock
                    fontName="bold"
                    textColor="theme-label"
                    fontSize="16_17"
                  >
                    {textCase(
                      flag === "1"
                        ? detail?.country_name!
                        : flag === "2"
                        ? detail?.state_name!
                        : flag === "3"
                        ? detail?.city_name!
                        : detail?.area_name!
                    )}
                  </TextBlock>
                </div>
              </ListItem>
            ))}
          </Listing>
        </>
      )}
    </Div>
  );
};
